import React from 'react';
import Typography from '@mui/material/Typography';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ChatWithDocuments from './chat-with-documents/ChatWithDocuments';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { DetailPanelType } from '../enum/DetailPanelTypeEnum';

interface BradyLinkProps {
  type: DetailPanelType;
  id: string;
  onlyShowId?: boolean;
  bNumber: string;
  isInDistillery?: boolean;
}

const BradyLink: React.FC<BradyLinkProps> = ({ type, id, onlyShowId = false, bNumber, isInDistillery }) => {
  const showChatWithDocument = type === DetailPanelType.Material && id && isInDistillery !== undefined;

  const handleChatWithTds = () => {
    const url = `https://www.bradyid.com/tdsdetails?id=${bNumber}`;
    window.open(url, '_blank');
  };

  return (
    <>
      <Typography variant="h2" component="h2">
        {type !== DetailPanelType.Material ? 'Product # ' + id : id}
        {!onlyShowId && ' Details'}
      </Typography>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={'10px'}>
        {bNumber && (
          <Button onClick={handleChatWithTds}>
            <Typography
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {`View ${bNumber} TDS`}
              <OpenInNewIcon fontSize="small" />
            </Typography>
          </Button>
        )}
        {showChatWithDocument && <ChatWithDocuments materialId={id} isInDistillery={isInDistillery} />}
      </Box>
    </>
  );
};

export default BradyLink;
